export default __webpack_public_path__ + "static/quantial-white-sm-e7b5840c449bb2307300611457c6a5ea.png";